import {EmailViewMode} from "./EmailViewMode";

export interface EmailViewOptions {
    viewMode: EmailViewMode;
}

export const defaultEmailViewOptions: EmailViewOptions = {
    viewMode: "thread-view",
}
